import { DeviceManifest } from '@rapoo/device-sdk'
import {
  itineraryEnabled,
  keyFeaturesFull,
  keyboardMacro,
  retailKeyboardConfig,
} from './generate/capabilityPresets'
import { esk90098Keys } from './generate/keysGenerate'
import { esk900KeyboardLightingEffects } from './generate/lightingPresets'

/**
 * ESK900-98RT 设备清单
 **/
const rapooESK90098RT: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESK900-98RT',
  mainControl: 'ESK900-98RT',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x481a],
    currentPid: 0x481a,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65392,
        usage: 113,
        description: 'Only update Firmware',
        type: 'update',
      },
    ],
  },
  driver: 'CH585M',
  ui: {
    assetsDir: 'manifests/ESK900-98RT',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.ESK900_98RT.Infernal_Asura',
          value: '#FF8226',
          key: 'Infernal_Asura',
        },
        {
          name: 'common.products.ESK900_98RT.Blaze_Wing_Star',
          value: '#FFD600',
          key: 'Blaze_Wing_Star',
        },
        {
          name: 'common.products.ESK900_98RT.Hacker_Agent',
          value: '#C1F627',
          key: 'Hacker_Agent',
        },
        {
          name: 'common.products.ESK900_98RT.Abyss_Ranger',
          value: '#8F23EC',
          key: 'Abyss_Ranger',
        },
        {
          name: 'common.products.ESK900_98RT.Zero_Flame',
          value: '#D61E1E',
          key: 'Zero_Flame',
        },
      ],
      current: 'Infernal_Asura',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: false,
  },
  capabilities: [
    // 产品确认 98 无需管理员配置，固件也未开发，所以不用同系列的 esk900KeyboardConfig
    retailKeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: esk900KeyboardLightingEffects,
      },
    },
    itineraryEnabled,
    keyFeaturesFull,
    {
      type: 'keys',
      config: esk90098Keys,
    },
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 35,
    bottom: 17,
    left: 15,
    right: 15,
    unit: 40,
    keys: [
      [
        {
          key: 0,
          keywords: 'Esc',
        },
        {
          key: 1,
          keywords: 'F1',
          x: 1,
        },
        {
          key: 2,
          keywords: 'F2',
        },
        {
          key: 3,
          keywords: 'F3',
        },
        {
          key: 4,
          keywords: 'F4',
        },
        {
          key: 5,
          keywords: 'F5',
          x: 0.5,
        },
        {
          key: 6,
          keywords: 'F6',
        },
        {
          key: 7,
          keywords: 'F7',
        },
        {
          key: 8,
          keywords: 'F8',
        },
        {
          key: 9,
          keywords: 'F9',
          x: 0.5,
        },
        {
          key: 10,
          keywords: 'F10',
        },
        {
          key: 11,
          keywords: 'F11',
        },
        {
          key: 12,
          keywords: 'F12',
        },
        {
          key: 13,
          keywords: 'Delete',
          x: 0.5,
        },
        {
          key: 14,
          keywords: 'PgUp',
        },
        {
          key: 15,
          keywords: 'PgDn',
        },
        {
          key: 16,
          keywords: 'RT',
        },
      ],
      [
        {
          key: 22,
          keywords: '~_`',
          y: 0.25,
        },
        {
          key: 23,
          keywords: '!_1',
          y: 0.25,
        },
        {
          key: 24,
          keywords: '@_2',
          y: 0.25,
        },
        {
          key: 25,
          keywords: '#_3',
          y: 0.25,
        },
        {
          key: 26,
          keywords: '$_4',
          y: 0.25,
        },
        {
          key: 27,
          keywords: '%_5',
          y: 0.25,
        },
        {
          key: 28,
          keywords: '^_6',
          y: 0.25,
        },
        {
          key: 29,
          keywords: '&_7',
          y: 0.25,
        },
        {
          key: 30,
          keywords: '*_8',
          y: 0.25,
        },
        {
          key: 31,
          keywords: '(_9',
          y: 0.25,
        },
        {
          key: 32,
          keywords: ')_0',
          y: 0.25,
        },
        {
          key: 33,
          keywords: '__-',
          y: 0.25,
        },
        {
          key: 34,
          keywords: '+_=',
          y: 0.25,
        },
        {
          key: 35,
          keywords: 'BackSpace',
          w: 2,
          y: 0.25,
        },
        {
          key: 36,
          keywords: 'NumLock',
          x: 0.5,
          y: 0.25,
        },
        {
          key: 37,
          keywords: '/',
          y: 0.25,
        },
        {
          key: 38,
          keywords: '*',
          y: 0.25,
        },
        {
          key: 39,
          keywords: '-',
          y: 0.25,
        },
      ],
      [
        {
          key: 44,
          keywords: 'Tab',
          w: 1.5,
          y: 0.25,
        },
        {
          key: 45,
          keywords: 'Q',
          y: 0.25,
        },
        {
          key: 46,
          keywords: 'W',
          y: 0.25,
        },
        {
          key: 47,
          keywords: 'E',
          y: 0.25,
        },
        {
          key: 48,
          keywords: 'R',
          y: 0.25,
        },
        {
          key: 49,
          keywords: 'T',
          y: 0.25,
        },
        {
          key: 50,
          keywords: 'Y',
          y: 0.25,
        },
        {
          key: 51,
          keywords: 'U',
          y: 0.25,
        },
        {
          key: 52,
          keywords: 'I',
          y: 0.25,
        },
        {
          key: 53,
          keywords: 'O',
          y: 0.25,
        },
        {
          key: 54,
          keywords: 'P',
          y: 0.25,
        },
        {
          key: 55,
          keywords: '{_[',
          y: 0.25,
        },
        {
          key: 56,
          keywords: '}_]',
          y: 0.25,
        },
        {
          key: 57,
          keywords: '|_\\',
          w: 1.5,
          y: 0.25,
        },
        {
          key: 58,
          keywords: '7_Home',
          x: 0.5,
          y: 0.25,
        },
        {
          key: 59,
          keywords: '8_↑',
          y: 0.25,
        },
        {
          key: 60,
          keywords: '9_PgUp',
          y: 0.25,
        },
        {
          key: 61,
          keywords: '+',
          h: 2,
          y: 0.25,
        },
      ],
      [
        {
          key: 66,
          keywords: 'CapsLock',
          w: 1.75,
          y: 0.25,
        },
        {
          key: 67,
          keywords: 'A',
          y: 0.25,
        },
        {
          key: 68,
          keywords: 'S',
          y: 0.25,
        },
        {
          key: 69,
          keywords: 'D',
          y: 0.25,
        },
        {
          key: 70,
          keywords: 'F',
          y: 0.25,
        },
        {
          key: 71,
          keywords: 'G',
          y: 0.25,
        },
        {
          key: 72,
          keywords: 'H',
          y: 0.25,
        },
        {
          key: 73,
          keywords: 'J',
          y: 0.25,
        },
        {
          key: 74,
          keywords: 'K',
          y: 0.25,
        },
        {
          key: 75,
          keywords: 'L',
          y: 0.25,
        },
        {
          key: 76,
          keywords: ':_;',
          y: 0.25,
        },
        {
          key: 77,
          keywords: '"_\'',
          y: 0.25,
        },
        {
          key: 78,
          keywords: 'Enter',
          w: 2.25,
          y: 0.25,
        },
        {
          key: 79,
          keywords: '4_←',
          x: 0.5,
          y: 0.25,
        },
        {
          key: 80,
          keywords: '5',
          y: 0.25,
        },
        {
          key: 81,
          keywords: '6_→',
          y: 0.25,
        },
      ],
      [
        {
          key: 88,
          keywords: 'Shift_L',
          w: 2.25,
          y: 0.25,
        },
        {
          key: 89,
          keywords: 'Z',
          y: 0.25,
        },
        {
          key: 90,
          keywords: 'X',
          y: 0.25,
        },
        {
          key: 91,
          keywords: 'C',
          y: 0.25,
        },
        {
          key: 92,
          keywords: 'V',
          y: 0.25,
        },
        {
          key: 93,
          keywords: 'B',
          y: 0.25,
        },
        {
          key: 94,
          keywords: 'N',
          y: 0.25,
        },
        {
          key: 95,
          keywords: 'M',
          y: 0.25,
        },
        {
          key: 96,
          keywords: '<_,',
          y: 0.25,
        },
        {
          key: 97,
          keywords: '>_.',
          y: 0.25,
        },
        {
          key: 98,
          keywords: '?_/',
          y: 0.25,
        },
        {
          key: 99,
          keywords: 'Shift_R',
          y: 0.25,
          w: 1.75,
        },
        {
          key: 100,
          keywords: '↑',
          x: 0.25,
          y: 0.4,
        },
        {
          key: 101,
          keywords: '1_End',
          x: 0.25,
          y: 0.25,
        },
        {
          key: 102,
          keywords: '2_↓',
          y: 0.25,
        },
        {
          key: 103,
          keywords: '3_PgDn',
          y: 0.25,
        },
        {
          key: 104,
          keywords: 'NumEnter',
          h: 2,
          y: 0.25,
        },
      ],
      [
        {
          key: 110,
          keywords: 'Ctrl_L',
          w: 1.25,
          y: 0.25,
        },
        {
          key: 111,
          keywords: 'Win_L',
          w: 1.25,
          y: 0.25,
        },
        {
          key: 112,
          keywords: 'Alt_L',
          w: 1.25,
          y: 0.25,
        },
        {
          key: 113,
          keywords: 'Space_L',
          w: 6.25,
          y: 0.25,
        },
        {
          key: 114,
          keywords: 'Fn',
          y: 0.25,
        },
        {
          key: 115,
          keywords: 'Ctrl_R',
          y: 0.25,
        },
        {
          key: 116,
          keywords: '←',
          x: 1.25,
          y: 0.4,
        },
        {
          key: 117,
          keywords: '↓',
          y: 0.4,
        },
        {
          key: 118,
          keywords: '→',
          y: 0.4,
        },
        {
          key: 119,
          keywords: '0_Ins',
          x: 0.25,
          y: 0.25,
        },
        {
          key: 120,
          keywords: '._Del',
          y: 0.25,
        },
      ],
    ],
  },
}

export default rapooESK90098RT
